import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core/styles';

export const FormContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3)
}));

export const FieldContainer = styled(Grid)({
  alignItems: 'center'
});

export const OtherOutcomeContainer = styled(Grid)({
  marginLeft: '16.67%'
});
